/**
 * This component renders the overview tab for a club page
 */
import React from "react";
import { useState } from "react";
import TrophyIcon from "./TrophyIcon";
import {Link} from "react-router-dom";
import ProfileImageContainer from "../core/ProfileImageContainer";

const ClubOverview = ({ data, gbs }) => {
  const [activeId, setActiveId] = useState(null);

  return (
    <>
        {/* About the club */}
        <h2 className="leading-tight text-left text-2xl font-semibold mb-2">About the Club</h2>
        {/* About the club text*/}
        <div
          className="max-xs:text-xs text-left text-darken club-detail w-full xs:pr-8"
          dangerouslySetInnerHTML={{ __html: data.detail }}
        ></div>

        {/* Club news */}

        {/* Teams info */}
        <h2 className="mt-4 text-left text-2xl font-semibold mb-2">Teams</h2>

        {/* For each team in data.team */}
        <div className="flex flex-col justify-start items-start w-full xs:pr-3 md:pr-8 xl:pr-10 ">
          {data.teams ? (
            data.teams.map((team) => (
              <div className="w-full">
                {team.rank > 0 && (team.committee.length > 0 || team.detail !== "" || team.titles.length > 0) ? (
                  <div className="flex flex-col justify-start items-start w-full mb-4">
                    <div className="border-2 border-light-3 dark:border-0 rounded flex flex-col justify-start items-start h-auto dark:bg-dark-4 py-2 px-3 w-full">
                      <div className="flex flex-row justify-start items-center w-full mb-1 w-full">
                        {/* Apply logic to manipulate data.img */}
                        {(() => {
                          // Render the img element with the updated data.img
                          return (
                            <img
                              src={data.img.md}
                              alt={team.name}
                              className="h-8 w-8"
                            />
                          );
                        })()}
                        {/* Render the team name */}
                        <h2 className="text-xl px-2 font-normal">
                          {team.name}
                        </h2>
                      </div>
                      {/* Team description */}
                      <div
                        className="pb-1 text-left max-xs:text-xs club-detail w-full"
                        dangerouslySetInnerHTML={{ __html: team.detail }}></div>

                      <div className="flex flex-wrap justify-start items-center w-full">
                          {team.committee.map((member) => (
                              <div className="w-full max-w-[240px] flex mt-1 mb-4">
                                  <Link
                                      to={`/player/${member.img}`}
                                      className="flex flex-row justify-start items-center group"
                                  >
                                      <div className="h-12 w-12 mr-2 xs:mr-3 rounded-full bg-white dark:bg-dark-2 flex flex-col justify-center items-center">
                                          <ProfileImageContainer
                                              player={member.img}
                                              club={member.club_id}
                                              backup={member.club_name}
                                              alt="Player image"
                                              extraClasses={"rounded-full"}
                                          />
                                      </div>
                                      <div className="flex flex-col justify-start items-start">
                                          <p className="text-center group-hover:text-buiha-red dark:group-hover:text-dark-5 ease-in-out duration-200 whitespace-nowrap">
                                              {member.name}
                                          </p>

                                          <p className="text-xs font-light">{member.role}</p>
                                          {/*<p className="text-darken text-xxs text-center font-light">{member.subtitle}</p>*/}
                                      </div>
                                  </Link>
                              </div>
                          ))}
                      </div>

                      <div className="flex flex-wrap justify-start items-center w-full">
                        {team.titles.map((title, index) => {
                          const id = `${team.name}-${index}`; // Create unique ID using team.name and index
                          return (
                            <TrophyIcon
                              key={id}
                              title={title}
                              id={id}
                              activeId={activeId}
                              setActiveId={setActiveId}
                            />
                          );
                        })}
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            ))
          ) : (
            <></>
          )}
        </div>
    </>
  );
};
export default ClubOverview;
